(function ($, dayjs) {

  $(document).on('submit', 'form', function () {
    var $form = $(this);
    $form.find('input[type=date]').each(function () {
      var $element = $(this);
      var date = dayjs($element.val(), ['DD.MM.YYYY', 'D.M.YYYY', 'YYYY-M-D', 'YYYY-MM-DD', 'DD.MM.YY', 'D.M.YY'], true);
      if (date.isValid()) {
        $element.val(date.format('YYYY-MM-DD'))
      }
    });
  })

})(window.jQuery, window.dayjs);
